import { useMediaLibrary } from "@/hooks/use-media-library";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { cn } from "@/lib/utils";

export function MediaSearchBar({
  state,
  onSearch,
}: {
  state: ReturnType<typeof useMediaLibrary>;
  onSearch?: () => void;
}) {
  const { query, setQuery, fetchMediaAssets, currentParentId } = state;
  return (
    <div className="flex-shrink-0 border-b border-slate-200 bg-white/50 px-4 py-3">
      <div className="relative group">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 transition-colors group-focus-within:text-slate-600" />
        <Input
          placeholder="Search by name, type…"
          className={cn(
            "pl-9 h-9 bg-white border-slate-300",
            "focus-visible:ring-2 focus-visible:ring-blue-500/20 focus-visible:border-blue-400",
            "transition-all duration-200"
          )}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter")
              (
                onSearch ||
                (() =>
                  fetchMediaAssets({ reset: true, parentId: currentParentId }))
              )();
          }}
        />
      </div>
    </div>
  );
}
